import { Component } from '@angular/core';
import { ArrayAssociative } from "./../core/array.core.data";
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { NeverumeComponent } from "./../neverume.component";
import { DomSanitizer } from '@angular/platform-browser';
import { WebsocketService } from "./../services/websocket.service";
import { Buffer } from 'buffer';

@Component({
	selector: 'neverume-avatarmaker',
	templateUrl: './avatarmaker.component.html',
	styleUrl: './avatarmaker.component.scss',
	standalone: !true
})
export class AvatarmakerComponent {

	currentDirection: any;
	path: any;
	rotation: any;
	outputpage: any;
	outputdraw: any;
	croppedpage: any;
	croppedprofile: any;
	neverume: any;
	pageChangedEvent: Event | null = null
	profileChangedEvent: Event | null = null;
	drawtype: any; pagetype: any;
	profiletype: any;
	outputprofile: any;
	lock: any = true;

	constructor(private websocketService: WebsocketService
		//private sanitizer: DomSanitizer
	) {
	}

	async fileChangeEvent(event: Event | any) {
		this.pageChangedEvent = null;
		this.profileChangedEvent = null;
		this.pageChangedEvent = event;
		this.profileChangedEvent = event;

	}

	pageCropped(event: ImageCroppedEvent) {

		this.croppedpage = event.objectUrl;
		var blob = event.blob;
		this.outputpage = blob;

		/*const byteCharacters = atob(event.base64);
			  const byteNumbers = new Array(byteCharacters.length);
			  for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			  }
			 const byteArray = new Uint8Array(byteNumbers);
			 this.outputpage = new Blob([byteArray], { type: event.fileType });*/

	}

	async pageLoaded(loaded: any) {
		const v = loaded.transformed.objectUrl;
		let blob = await fetch(v).then(k => k.blob());
		this.outputdraw = await blob.arrayBuffer();
		this.drawtype = blob.type;
	}

	pageCropperReady() {

	}

	thumbCropped(event: ImageCroppedEvent) {
		this.croppedprofile = event.objectUrl;
		this.outputprofile = event.blob;
	}
	thumbLoaded() {
	}

	thumbCropperReady() {
	}
	/*   imageCropped(event: ImageCroppedEvent) {
			this.croppedImage = event.base64;
		  }*/
	loadImageFailed() {
		console.log('Load failed');
	}

	async onSubmit() {
		if (this.lock && this.outputprofile != undefined && this.outputpage != undefined && this.outputpage.size != undefined && this.outputprofile.size != undefined) {

			this.lock = false;
			var pageb: Buffer | string | null = null, profile: Buffer | string | null = null;
			if (this.outputprofile.size > 0) {
				profile = await this.outputprofile.arrayBuffer();
				console.log(profile);
				if (this.outputpage.size > 0) {
					pageb = await this.outputpage.arrayBuffer();
					let message: ArrayAssociative = {
						event: 'makeavatar',
						route: '/profile/addavatar',
						page: pageb,//btoa(unescape(encodeURIComponent(new TextDecoder("utf-8").decode(await this.outputpage.arrayBuffer())))),
						pagetype: this.outputpage.type,
						draw: this.outputdraw,
						drawtype: this.drawtype,
						profile: profile,
						profiletype: this.outputprofile.type
					}


					let draw = this.outputdraw;
					this.websocketService.sendws(
						await message
					);
				}
			}
			this.lock = true
		}
	}
}
